export class WebhookV1StandardPayloadMpaRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadMpaRequestTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadMpaRequestArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadMpaRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadMpaRequestTypeEnum;
(function (WebhookV1StandardPayloadMpaRequestTypeEnum) {
    WebhookV1StandardPayloadMpaRequestTypeEnum["PendingApproval"] = "MPA_REQUEST_PENDING_APPROVAL";
    WebhookV1StandardPayloadMpaRequestTypeEnum["Executed"] = "MPA_REQUEST_EXECUTED";
    WebhookV1StandardPayloadMpaRequestTypeEnum["Expired"] = "MPA_REQUEST_EXPIRED";
    WebhookV1StandardPayloadMpaRequestTypeEnum["Cancelled"] = "MPA_REQUEST_CANCELLED";
})(WebhookV1StandardPayloadMpaRequestTypeEnum || (WebhookV1StandardPayloadMpaRequestTypeEnum = {}));
